const navigate = (path) => {
	window.location.href = path;
};

export default navigate;
